import Content from './elements/Content';
import Play from './elements/Play';
import clsx from 'clsx';
import { selectApp } from 'store/app/slice';
import { useTypedSelector } from 'hooks/useStore';
import { Header } from 'components';
import './Hero.scss';

const Hero: React.FC = (props) => {
  const { isIntro } = useTypedSelector(selectApp);
  return (
    <div className={clsx('hero', { animation: !isIntro })} id="hero">
      <Header />
      <Play />
      <img
        src={require('images/hero/ripple.png')}
        alt="background-ripple"
        className="hero__ripple"
      />
      <Content />
    </div>
  );
};

export default Hero;
